var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"sm-notification__inner"},[_c('include-svg',{attrs:{"name":'icon-warning'}}),_c('span',[_vm._v("Your Photo ID is expired.")]),_c('a',{staticClass:"sm-txt-strong",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.uploadPhotoID.apply(null, arguments)}}},[_vm._v("Update")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }